export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_22-15f1a2be186a181f376762d6bc4bae4d.jpg";